import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {LoadingComponent} from './loading.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        LoadingComponent
    ],
    exports: [
        LoadingComponent
    ]
})
export class LoadingModule {
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/loading/loading.module.ts